import React, { useState } from 'react'
import { TextInput } from './TextInput'
import EyeIcon from '@/CustomIcons/EyeIcon'
import EyeClosedIcon from '@/CustomIcons/EyeClosedIcon'
import type { TextInputProps } from './TextInput'

type PasswordInputProps = Omit<TextInputProps, 'type' | 'rightControl'>

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
        <TextInput
            type={showPassword ? 'text' : 'password'}
            {...props}
            rightControl={
                <button
                    className="cursor-pointer opacity-50"
                    onClick={(e) => {
                        e.preventDefault()
                        setShowPassword(!showPassword)
                    }}
                >
                    {showPassword ? <EyeIcon /> : <EyeClosedIcon />}
                </button>
            }
        />
    )
}
